module.exports = __webpack_public_path__ + "img/C922.76d69068.jpg";